<template>
  <div class="page-background" ref="pageBackground">
    <div class="page-content" :style="pageStyle">
      <component
        v-for="item in pageConfig.componentConfig"
        :id="item.id"
        :key="item.id"
        :is="item.component"
        :cid="item.componentId"
        :tags="item.tags"
        :uid="item.id"
        :uname="item.name"
        :ref="item.id"
        :styles="transformStyle(item.styles)"
        :configuration-data="item.configurationData"
        :interval-data-fetch-list="item.intervalDataFetchList"
        :events="item.events"
        @component-event-emitted="handleComponentEvents(arguments, item.id)"
        @defined-event-emitted="handleDefinedEvents"
      >
        <template v-for="(firstSlotComopnents, firstSlotName) in item.childrenSlots" #[firstSlotName]>
          <template v-for="child in firstSlotComopnents">
            <component
              :id="child.id"
              :key="child.id"
              :is="child.component"
              :cid="child.componentId"
              :tags="child.tags"
              :uid="child.id"
              :uname="child.name"
              :ref="child.id"
              :styles="child.styles"
              :configuration-data="child.configurationData"
              :interval-data-fetch-list="child.intervalDataFetchList"
              :events="child.events"
              @component-event-emitted="handleComponentEvents(arguments, child.id)"
              @defined-event-emitted="handleDefinedEvents"
            >
              <template v-for="(secondSlotComponents, secondSlotName) in child.childrenSlots" #[secondSlotName]>
                <template v-for="secondChild in secondSlotComponents">
                  <component
                    :id="secondChild.id"
                    :key="secondChild.id"
                    :is="secondChild.component"
                    :cid="secondChild.componentId"
                    :tags="secondChild.tags"
                    :uid="secondChild.id"
                    :uname="secondChild.name"
                    :ref="secondChild.id"
                    :styles="secondChild.styles"
                    :configuration-data="secondChild.configurationData"
                    :interval-data-fetch-list="secondChild.intervalDataFetchList"
                    :events="secondChild.events"
                    @component-event-emitted="handleComponentEvents(arguments, secondChild.id)"
                    @defined-event-emitted="handleDefinedEvents"
                  >
                  </component>
                </template>
              </template>
            </component>
          </template>
        </template>
      </component>
    </div>
  </div>
</template>
<script>
import mixin from '@tencent/ceiba-ui/ui-mixin';
const constant = {
  // 屏幕
  SCREEN_WIDTH: typeof document !== 'undefined' ? document.documentElement.clientWidth : 0,
  SCREEN_HEIGHT: typeof document !== 'undefined' ? document.documentElement.clientHeight : 0,
  // H5横屏设计稿背景图ihpnex
  H5_H_DESIGN_BG_WIDTH: 1624,
  H5_H_DESIGN_BG_HEIGHT: 750,
  // H5横屏居中编辑区域
  H5_H_DESIGN_WIDTH: 1334,
  H5_H_DESIGN_HEIGHT: 750,
};

export default {
  name: 'CPageH5H',
  mixins: [mixin],
  data() {
    return {
      designWhRatio: constant.H5_H_DESIGN_WIDTH / constant.H5_H_DESIGN_HEIGHT,
      designHwRatio: constant.H5_H_DESIGN_HEIGHT / constant.H5_H_DESIGN_WIDTH,
      currentWhRatio: constant.SCREEN_WIDTH / constant.SCREEN_HEIGHT,
    };
  },
  computed: {
    // 页面分辨率
    resolution() {
      let rectWidth = 0;
      let rectHeight = 0;
      console.log('this.currentWhRatio=', this.currentWhRatio, 'this.designWhRatio=', this.designWhRatio);
      if (this.currentWhRatio >= this.designWhRatio) {
        // 宽高比大于设计稿宽高比，则实际尺寸更宽，则高撑满，两边用实际背景图填充
        rectHeight = constant.SCREEN_HEIGHT;
        rectWidth = this.designWhRatio * constant.SCREEN_HEIGHT;
      } else {
        // 宽高比小于设计稿宽高比，则实际尺寸更高，则宽撑满，上下用实际背景图填充
        rectWidth = constant.SCREEN_WIDTH;
        rectHeight = this.designHwRatio * constant.SCREEN_WIDTH;
      }
      console.log('rectWidth=', rectWidth, '|rectHeight=', rectHeight);
      return {
        width: rectWidth,
        height: rectHeight, // 0.7版本,高度自适应,
      };
    },
    // 分辨率样式
    resolutionStyle() {
      return {
        width: `${this.resolution.width}px`,
        height: `${this.resolution.height}px`,
      };
    },
    // 页面样式，目前仅包含 width height backgroundColor
    pageStyle() {
      return {
        ...this.resolutionStyle,
        margin: 'auto', // 居中
        // border: '1px solid red',
      };
    },
  },
  methods: {
    hookOnPageChange() {
      console.log('hook h5-h page change : ');
      this.initBackgroundImageStyle();
    },
    initBackgroundImageStyle() {
      const { backgroundImage } = this.pageConfig.canvasConfig || {};
      if (!backgroundImage) {
        return {};
      }
      const backgroundColor = this.pageConfig.canvasConfig.background || '#ffffff';
      const designBgWhRatio = constant.H5_H_DESIGN_BG_WIDTH / constant.H5_H_DESIGN_BG_HEIGHT; // 默认1624/750
      let backgroundWidth = 0;
      let backgroundHeight = 0;
      let backgroundPositionWidth = 0;
      const backgroundPositionHeight = 0;
      backgroundHeight = this.resolution.height; // 只做高撑满处理
      if (this.currentWhRatio >= this.designWhRatio) {
        // 宽度太长了，也是高度撑满，两边留白
        backgroundWidth = constant.SCREEN_HEIGHT * designBgWhRatio;
        backgroundPositionWidth = (constant.SCREEN_WIDTH - backgroundWidth) / 2;
      } else {
        // 比如ipad, RECT应该是resolution
        backgroundWidth = this.resolution.height * designBgWhRatio;
        backgroundPositionWidth = (this.resolution.width - backgroundWidth) / 2;
      }
      console.log('backgroundWidth=', backgroundWidth, '|backgroundHeight=', backgroundHeight);
      console.log(
        'backgroundPositionWidth=',
        backgroundPositionWidth,
        '|backgroundPositionHeight=',
        backgroundPositionHeight,
      );
      const style = {
        background: `url(${backgroundImage.src}) no-repeat`,
        backgroundSize: `${backgroundWidth}px ${backgroundHeight}px`, // 写死背景图宽度
        backgroundPosition: `${backgroundPositionWidth}px ${backgroundPositionHeight}px`,
      };
      console.log('style=', style);
      this.$refs.pageBackground.style.background = `url(${backgroundImage.src}) no-repeat`;
      this.$refs.pageBackground.style.backgroundSize = `${backgroundWidth}px ${backgroundHeight}px`; // 写死背景图宽度
      this.$refs.pageBackground.style.backgroundPosition = `${backgroundPositionWidth}px ${backgroundPositionHeight}px`;
      this.$refs.pageBackground.style.backgroundColor = backgroundColor;
    },
    transformStyle(styles) {
      const style = styles;
      if (style.base && style.base.position === 'fixed') {
        console.log('style.base=', style.base);
        // 处理宽高撑满
        if (style.base.widthFill === true) {
          const scale = constant.SCREEN_WIDTH / this.resolution.width;
          const fixedModeArr = (style.base.fixedMode || 'left_top').split('_');
          style.base.left = 0;
          style.base.right = 0;
          style.base.transformOrigin = `${fixedModeArr[0]} ${fixedModeArr[1]}`;
          style.base.transform = `scale(${scale})`;
        }
        if (style.base.heightFill === true) {
          const scale = constant.SCREEN_HEIGHT / this.resolution.height;
          const fixedModeArr = (style.base.fixedMode || 'left_top').split('_');
          style.base.top = 0;
          style.base.bottom = 0;
          style.base.transformOrigin = `${fixedModeArr[0]} ${fixedModeArr[1]}`;
          style.base.transform = `scale(${scale})`;
        }
      }
      return style;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@tencent/ceiba-base-components/index.scss';
@import './styles.scss';

.page-background {
  position: relative;
  width: 100%;
  overflow-x: hidden;

  .page-content {
    position: relative;
  }
}
</style>
